import { useNewEmailIsAnyAttachmentNotReady } from '@/views/emails/context/NewEmails.ts';

export const useAnyAttachmentIsNotReady = (): boolean => {
  return useNewEmailIsAnyAttachmentNotReady();
};
